import * as React from "react";
import { IComponentDataItem } from "../../../../core/types/IComponentDataItem";
import { IComponentField } from "../../../../core/types/IComponentField";
import PaginationView from "../../../components/paginationView/PaginationView";
import TableHeaderSection from "../../../components/tableHeaderSection/TableHeaderSection";
import { createCopyOfTableContents } from "../../../services/TableFunctions";
import { IMyPackagesDetails } from "../../../types/IMyPackagesDetails"; 
import DateDisplay from "../../../components/dateDisplay/DateDisplay";
import IRepertoireComponentData from "../../../../redux/types/IRepertoireComponentData";
import IRepertoireComponentDataItem from "../../../../redux/types/IRepertoireComponentDataItem";
import { IRepertoireField } from "../../../types/IRepertoireField";
import IconTextButton from "../../../components/iconTextButton/IconTextButton";
import moment from 'moment';
import { EntityType } from "../../../types/EntityType";
import { RepertoireService } from "../../../../redux/services/RepertoireService";
import { PAGINATION } from "../../../Consts";

export interface IMyPackagesGridViewProps {
    myPackagesGridView: IRepertoireComponentDataItem;
    tableContents: IMyPackagesDetails[];
    newSearch?: boolean;
    currentUser?:string;
    getMyPackagesDetails?: (userName: string, modalOpen: boolean) => void;
    componentInstance?:string;   
}

interface IMyPackagesGridViewState {
    tableContents: IMyPackagesDetails[];
    activeSortHeaderSection: string;
    indexOfFirstResult: number;
    indexOfLastResult: number;
    resultsPerPage: number;
    currentPage: number;
   }

export default class MyPackagesGridView extends React.PureComponent<
IMyPackagesGridViewProps,
IMyPackagesGridViewState
    > {
    widthStyles: { width: string; }[];

    constructor(props: IMyPackagesGridViewProps) {
        super(props);

        this.state = {
            tableContents: props.tableContents,
            activeSortHeaderSection: undefined,
            indexOfFirstResult: 0,
            indexOfLastResult: 10,
            resultsPerPage: 10,
            currentPage: 1
        };
        this.widthStyles = [
            { width: '10%' },
            { width: '15%' },
            { width: '35%' },
            { width: '40%' }
        ];
    }

    public ascending: boolean = false;

    componentDidUpdate = (prevProps: IMyPackagesGridViewProps) => {
        const { tableContents, newSearch } = this.props;
        const { indexOfLastResult, resultsPerPage } = this.state;
       
        if (prevProps.tableContents !== tableContents) {         
            this.setState({
                tableContents
            });
        }
        if(newSearch){
            this.updateContentsTable(0, indexOfLastResult, resultsPerPage, 1)
        }
    };


    sortTableByColumn = (section: string) => {
        const { activeSortHeaderSection, tableContents } = this.state;
        const tableContentsCopy = createCopyOfTableContents(tableContents);

        if (activeSortHeaderSection !== section) {
            this.ascending = false;
        }

        tableContentsCopy.sort((a: any, b: any) => {
            // set to emtpy string if null
            let newA = a[section] || "";
            let newB = b[section] || "";

            newA = newA ? newA : "";
            newB = newB ? newB : "";

            if (!this.ascending) {
                return newA.toString().localeCompare(newB.toString(), undefined, { 'numeric': true });
            }
            return newB.toString().localeCompare(newA.toString(), undefined, { 'numeric': true });
        });

        this.setState({
            tableContents: tableContentsCopy,
            activeSortHeaderSection: section
        });

        this.ascending = !this.ascending;
    };

    updateContentsTable(indexOfFirstResult: number, indexOfLastResult: number, resultsPerPage: number, currentPage: number): void {
        this.setState({ indexOfFirstResult, indexOfLastResult, resultsPerPage, currentPage });
    }

    renderHeaderSections = () => {
        const { myPackagesGridView } = this.props;
        const { activeSortHeaderSection } = this.state;
    
        if (myPackagesGridView && myPackagesGridView.fields) {
            const filteredFields = myPackagesGridView.fields.filter(f => 
                f.componentInstance !== PAGINATION
                && f.name !== "donloadLinkAvailabilityMessage"
            );

            return filteredFields.map((section: IRepertoireField, index: number) => {
               
                return (
                    <td key={index} className="td" >
                        <TableHeaderSection
                            section={section.data}
                            fieldName={section.name}
                            isSortingActive={section.name === activeSortHeaderSection}
                            ascending={this.ascending}
                            onClickHeaderSection={this.sortTableByColumn}
                            sortable
                        />
                    </td>
                );
            });
        }
    };
    renderPaginationView(): JSX.Element {
        const { tableContents, resultsPerPage, currentPage } = this.state;
        const { myPackagesGridView } = this.props;
        const paginationData = myPackagesGridView.fields.filter(f => f.componentInstance === PAGINATION)

        return <PaginationView
            contentsLength={tableContents ? tableContents.length : 0}
            resultsPerPage={resultsPerPage}
            currentPage={currentPage}
            updateContentsTable={this.updateContentsTable.bind(this)}
            paginationData={paginationData}
        />
    }

    onDownloadFile(downloadlink, fileFormat) {
        RepertoireService.downloadFile(downloadlink, fileFormat).then(
            (downloadLink: string) => {
                const link = document.getElementById("downloadLinkPackages");
                link.setAttribute('href', downloadLink);
                link.click();
                link.removeAttribute('href');
            }
        );
    }

    renderSearchResults = () => {

        const { indexOfFirstResult, indexOfLastResult,tableContents } = this.state;
        const { myPackagesGridView } = this.props;
        const filteredFields = myPackagesGridView.fields.filter(f => 
            f.componentInstance !== PAGINATION
            && f.name !== "donloadLinkAvailabilityMessage"
        )
        
       if (tableContents && tableContents.length > 0) {
        const currentResults = tableContents.slice(
            indexOfFirstResult,
            indexOfLastResult
        );

            const keys: { name, title }[] = [];
            filteredFields.map(field => keys.push({ name: field.name, title: field.data }));

            return currentResults.map(
                (tableContentItem: any, index: number) => {
                    const sections: JSX.Element[] = [];                   
                    keys.map((key: { name, title }, x: number) => {
                      
                        if (key.name.trim().toLowerCase() === 'downloadlink') {
                            sections.push(
                                ((tableContentItem[key.name] !== null && tableContentItem["downloadFileFormat"] !== null && tableContentItem["downloadLink"]!==null) ? <td key={`${index}.${x}`} className="td" title={key.title} style={this.widthStyles[x] || {}}>
                                    <div className="tableCell wrapText" style={{ paddingLeft: '15px' }}>
                                      {tableContentItem[key.name] &&
                                        <IconTextButton
                                            icon={"icon ms-Icon ms-Icon--Download"}
                                            onClick={() => this.onDownloadFile(tableContentItem[key.name], tableContentItem["downloadFileFormat"])}
                                        />
                                      }
                                    </div>
                                </td>:
                                (tableContentItem["status"] === "In Progress" && tableContentItem["downloadLink"] === null 
                                    ? <td className="td"><div className= "paddingMedium"style={{fontSize: '13px'}}>{myPackagesGridView.fields.find(f => f.name === "donloadLinkAvailabilityMessage")?.data}</div></td> 
                                    : null)
                                ));
                            return;
                        } else if (key.name.trim().toLowerCase() === 'lastmodifiedate') {  
                            sections.push(
                                <td key={`${index}.${x}`} className="td" title={key.title} style={this.widthStyles[x] || {}} >
                                    <div className="tableCell wrapText">
                                       {moment(tableContentItem[key.name]).format("DD/MM/YYYY hh:mm A")}
                                    </div>
                                </td>
                            );
                            return;
                        } else {
                            sections.push(
                                <td key={`${index}.${x}`} className="td" title={key.title} style={this.widthStyles[x] || {}}>
                                    <div className="tableCell wrapText">
                                        {tableContentItem[key.name]}
                                    </div>
                                </td>
                            );
                        }
                            
                        }
                    
                    );
                    
                    return <tr key={index} className="tr">
                        {sections}
                    </tr>
                }
            );
       }
    };

    render() {
        return (
             <div className="SearchResultsTable">
                 {this.renderPaginationView()}
                 <div className="tableContainer">
                     <table className="table">
                         <thead className="thead">
                             <tr className="tr">{this.renderHeaderSections()}</tr>
                         </thead>
                         <tbody className="tbody">{this.renderSearchResults()}</tbody>
                     </table>
                     {this.renderPaginationView()}
                 </div>
             </div>
        );
    }
}
